import { Loader2, X } from "lucide-react";

export default function DeleteResourceModal({ resource, onClose, onConfirm, isDeleting }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-lg w-[90%] max-w-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-popinsSemiBold text-lg">Delete Resource</h2>
          <button onClick={onClose} className="text-black/40 hover:text-black/70">
            <X size={20} />
          </button>
        </div>
        <p className="font-popinsRegular text-sm text-black/60 mb-6">
          Are you sure you want to delete <span className="font-popinsMedium text-black/80">"{resource.title}"</span>? This action cannot be undone.
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="px-4 py-2 rounded-md border border-border font-popinsMedium text-sm text-black/60 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 rounded-md bg-red-500 text-white font-popinsMedium text-sm hover:bg-red-600 disabled:opacity-50 flex items-center gap-2"
          >
            {isDeleting && <Loader2 size={14} className="animate-spin" />}
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
